export default "__VITE_ASSET__C2jlOw5P__"